jQuery.noConflict();
jQuery(document).ready(function(){ 
  if( $('.galeriequatro').length > 0 ) {
    var allitems = $('.galeriequatro_item').length;
    var items = 8;
    if ( allitems > items ) {
      $( '.galeriequatro_button' ).show();
    }
    $('.galeriequatro_item:lt('+items+')').show();
    // End
    // Afficher 2 fichiers en plus en cliquant sur le boutton voir plus
    $( '.galeriequatro_button' ).click(function() {
      items = items + 4;
      $('.galeriequatro_item:lt('+items+')').show();
      if ( items >= allitems ) {
        $( '.galeriequatro_button' ).hide();
      }
    });
    $( '.galeriequatro_button' ).keypress(function (e) {
      var key = e.which;
      if( (key == 13) || (key == 32) ) 
      {
        items = items + 4;
        $('.galeriequatro_item:lt('+items+')').show();
        if ( items >= allitems ) {
          $( '.galeriequatro_button' ).hide();
        }
        return false;
      }
    });
    // End
  }
});
